import React from 'react';
import DefaultLayout from '../../../layouts/default';

// Import local fire safety compliance components
import FireSafetyComplianceOverview from './components/FireSafetyComplianceOverview';
import FireSafetyDashboardTables from './components/FireSafetyDashboardTables';
import FireSafetyAlertsDashboard from './components/FireSafetyAlertsDashboard';
import FireSafetyAuditFooterDashboard from './components/FireSafetyAuditFooterDashboard';

function FireSafetyComplianceCenter() {
  return (
    <DefaultLayout>
      <div className="flex flex-col gap-6 bg-slate-50 min-h-screen">
        {/* Metric Summary Ribbon Cards */}
        <FireSafetyComplianceOverview />

        {/* Aggregated Categorical and Locational Grid Summaries */}
        <FireSafetyDashboardTables />

        {/* Detailed Breakdown Panels and Distribution Lists */}
        <FireSafetyAlertsDashboard />

        {/* Informational Subtext & Verified Auditing Action Trail Logs */}
        <FireSafetyAuditFooterDashboard />
      </div>
    </DefaultLayout>
  );
}

export default FireSafetyComplianceCenter;
